import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// import { IMeasure } from '../model/IMeasure';
import { Polygon, Feature }  from 'geojson';
import { IGetMeasure } from '../apis/apiSlice';

export interface IMeasureState {
  coordinates: Array<number>;
  measureToEdit: IGetMeasure | null; 
  measureDialogOpen: boolean;
  measureAreaFeatures: Array<any>;
  measureAreaPolygons: Array<any>;
}

const initState = {
  coordinates: Array<number>(),
  measureToEdit: null,
  measureDialogOpen: false,
  measureAreaFeatures: Array<any>(),
  measureAreaPolygons: Array<any>()
} as IMeasureState

const measureSlice = createSlice({
  name: 'measures',
  initialState: initState as IMeasureState,
  reducers: {
    resetMeasures: (): IMeasureState => {     
      return initState as IMeasureState;
    },
    measureDialogOpened: (
      state,
      action: PayloadAction<boolean>
    ): IMeasureState => {     
      return {...state, measureDialogOpen: action.payload, coordinates: Array<number>()};
    },
    coordinatesSet: (
      state,
      action: PayloadAction<Array<number>>
    ): IMeasureState => {     
      return {...state, coordinates: action.payload, measureDialogOpen: action.payload !== null};
    },
    measureAreaFeaturesAdded: (
      state,
      action: PayloadAction<Array<Feature<Polygon>>>
    ): IMeasureState => {

      const features = state.measureAreaFeatures.concat(action.payload) as Array<Feature<Polygon>>
      const polygons = features.map((feature: Feature<Polygon>) => feature.geometry)
      return {
        ...state,
        measureAreaFeatures: features,
        measureAreaPolygons: polygons
      }
    },
    measureSet: (
      state,
      action: PayloadAction<IGetMeasure | null>
    ): IMeasureState => {
      return {
        ...state,
        measureToEdit: action.payload, measureDialogOpen: action.payload !== null
      }
    }
  } 
})


export const {
  measureSet,
  coordinatesSet,
  measureDialogOpened,
  measureAreaFeaturesAdded,
  resetMeasures
} = measureSlice.actions

export default measureSlice.reducer

